const images = [
  {
    id: 1,
    image: "images/image1.jpg",
    imageTwo: "images/image1.jpg",
    titleTwo: "Look More Here. Get More Results",
    title: "ORGANIZED FOOD CAMP FOR CHILD",
    description: "At least 19 people have died with dozens missing after a landslide hit a camping site in Malaysia state of emergency following violent protests over the president impeachment",
    seeMore: "See More",
  },
  {
    id: 2,
    image: "images/image2.jpg",
    imageTwo: "images/image2.jpg",
    titleTwo: "Look More Here. Get More Results",
    title: "SPECIAL FOOD CAMP FOR CHILD",
    description:
      "At least 19 people have died with dozens missing after a landslide hit a camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over the president impeachment Peru has declared a 30-day",
    seeMore: "See More",
  },
  {
    id: 3,
    image: "images/image3.jpg",
    imageTwo: "images/image3.jpg",
    titleTwo: "Get More Results.Look More Here.",
    title: "WELL DARE FOOD CAMP FOR CHILD",
    description:
      "At least 19 people have died with dozens missing after a landslide hit Peru has declared a 30-day a camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over the president impeachment",
    seeMore: "See More",
  },
  {
    id: 4,
    image: "images/image4.jpg",
    imageTwo: "images/image4.jpg",
    titleTwo: "Get More Results.Look More Here.",
    title: "ORGANIZED FOOD CAMP FOR CHILD",
    description:
      "At least 19 people have died with dozens missing after a landslide hit a camping site in Malaysia Peru has declared a 30-day state of emergency following violent protests over the president impeachment",
    seeMore: "See More",
  },
];
export default images;
